<template>
  <div class="section-card" v-if="signals && signals.length > 0">
    <div class="section-header">
      <div class="section-title">
        <div class="icon-wrap">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
          </svg>
        </div>
        Listing Signals
      </div>
    </div>
    <div class="listing-signals">
      <div v-for="(signal, index) in signals" :key="index" class="signal-item">
        <div class="signal-icon">{{ signal.icon }}</div>
        <div class="signal-body">
          <div class="signal-name">{{ signal.name }}</div>
          <div class="signal-status" :class="signal.active ? 'active' : 'inactive'">
            <span class="signal-dot"></span>{{ signal.active ? 'Active' : 'Not active' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListingSignals',
  props: {
    signals: {
      type: Array,
      default: function() { return [] }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ListingSignals.vue?387896ca